namespace SP {

    export type GS1Data = {
        fullCode?: string;
        GTIN?: string;
        bestBeforeDate?: string;
        productionDate?: string;
        batchOrLotNumber?: string;
        orderNumber?: string;
    };

    function isGS1Barcode(barcode: string): boolean {
        if (!barcode || !barcode.length || !(barcode[0] == "(")) return false;
        // Check for the presence of parentheses enclosing Application Identifiers (AIs) followed by numeric data
        const gs1Pattern = /\(\d{2,4}\)\d+/g;
        return gs1Pattern.test(barcode);
    }


    function parseGS1Barcode(barcode: string): GS1Data {
        let result: GS1Data = {};
        let data: { [ai: string]: string } = {};

        let currentIndex = 0;
        while (currentIndex < barcode.length) {
            // Find the start of the AI
            let startAIPos = barcode.indexOf("(", currentIndex);
            let endAIPos = barcode.indexOf(")", startAIPos);

            if (startAIPos === -1 || endAIPos === -1) break;

            const ai = barcode.substring(startAIPos + 1, endAIPos);

            currentIndex = endAIPos + 1; // Move currentIndex past the closing parenthesis of AI

            const endOfData = barcode.indexOf("(", currentIndex);
            const dataLength = endOfData === -1 ? barcode.length - currentIndex : endOfData - currentIndex;

            data[ai] = barcode.substring(currentIndex, currentIndex + dataLength); // Extract the data
            currentIndex += dataLength;
        }

        console.log(data);

        for (let ai in data) {
            switch (ai) {
                case "01":
                    result.GTIN = data[ai];
                    break;
                case "11":
                    const dateStrProductionDate = data[ai];
                    result.productionDate = `20${dateStrProductionDate.substring(0, 2)}-${dateStrProductionDate.substring(2, 4)}-${dateStrProductionDate.substring(4, 6)}`;
                    break;
                case "15":
                    const dateStrBestBefore = data[ai];
                    result.bestBeforeDate = `20${dateStrBestBefore.substring(0, 2)}-${dateStrBestBefore.substring(2, 4)}-${dateStrBestBefore.substring(4, 6)}`;
                    break;
                case "10":
                    result.batchOrLotNumber = data[ai];
                    break;
                case "400":
                    result.orderNumber = data[ai];
                    break;
            }
        }

        return result;
    }

    //function parseGS1Barcode(barcode: string): GS1Data {
    //    let result: GS1Data = {};
    //    let data: {[ai: string]: string} = {};

    //    let currentIndex = 0;
    //    while (currentIndex < barcode.length) {
    //        const ai = barcode.substring(currentIndex + 1, currentIndex + 3); // Extracting Application Identifier (AI)
    //        currentIndex += 4; // Move currentIndex past AI and both parentheses

    //        const endOfData = barcode.indexOf("(", currentIndex);

    //        // Get the length of data until next identifier or until the end if no more identifiers
    //        const dataLength = endOfData === -1 ? barcode.length - currentIndex : endOfData - currentIndex;

    //        data[ai] = barcode.substring(currentIndex, currentIndex + dataLength); // Extract the data
    //        currentIndex += dataLength; 
    //    }
    //    console.log("DATA:", data);
    //    for (let ai in data) {
    //        switch (ai) {
    //            case "01":
    //                result.GTIN = data[ai];
    //                break;
    //            case "15":
    //                const dateStr = data[ai];
    //                result.bestBeforeDate = `20${dateStr.substring(0, 2)}-${dateStr.substring(2, 4)}-${dateStr.substring(4, 6)}`;
    //                break;
    //            case "10":
    //                result.batchOrLotNumber = data[ai];
    //                break;
    //            case "400":
    //                result.orderNumber = data[ai];
    //                break;
    //        }
    //    }

    //    return result;
    //}


    export class BarcodeEngine {
        code_commands: { [command: string]: ((code: string) => void)[] } = {};
        _startCallbacks: (() => void)[] = [];
        _convertScanMethods: ((code: string) => Promise<boolean>)[] = [];
        debug: boolean = false;
        timeout: NodeJS.Timeout;
        _startSymbol: string = '{';
        _endSymbol: string = '}';
        _reading: boolean = false;
        _input: string = "";
        paused: boolean = false;
        debugView: HTMLTextAreaElement;
        slaveMode: boolean = false;
        outputInput: HTMLInputElement;
        bannedKeycodes: number[] = [
            0, //null
            9, //Tab
            16, //Shift
            17, //Control
            18, //Alt-GR
            20, //Caps Lock
            27, //Escape
            91, //Meta/Windows
        ];
        constructor() {
            //if (typeof ((window as any).Android) != 'undefined') {
            //    //tell KB to return results via JS function
            //    (window as any).Android.useJavaScriptCallbackGenericScanner(true);
            //    SP.alertX("enabled for android api scanning");
            //}
            //else {
            //    SP.alertX("android api not found");
            //}


            //(window as any).barcodeScanResult = (data: string) => {
            //    SP.alertX("api scan:" + data);
            //    console.log(data);
            //}



            if (this.debug) {
                this.debugView = document.createElement("textarea");
                document.body.prepend(this.debugView);
                this.debugView.setAttribute("readonly", "true");
                this.debugView.setAttribute("style", "position:fixed; width:100%; bottom:0; pointer-events:none; z-index: 1000; text-align:center; background-color:rgba(255,255,255,0.5)")
            }


            document.onkeydown = (e) => {
                if (this.paused) return;
                if (this.bannedKeycodes.indexOf(e.keyCode) != -1) return;

                if (this.debug) {
                    if (!this._input.length) this.debugView.value = "";
                    this.debugView.value += e.key + "(" + e.keyCode + ")";
                }



                //clear after 100ms
                if (this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = null;
                }




                if ((this._endSymbol == null && e.keyCode == 13) || this._endSymbol == e.key) {
                    if (this._input.length) {
                        if (this.debug) this.debugView.value += "\n Scanned Barcode = " + this._input.trim() + "\n";
                        this.performScan(this._input.trim(), false);
                        this.reset();
                    }

                }
                else {

                    if (!this._reading && (!this._startSymbol || e.key == this._startSymbol)) {
                        this.reset();
                        this._reading = true;

                       
                        if (this._startSymbol) {
                            this._startCallbacks.forEach(cb => cb());
                        }
                    }
                    else if (this._reading) {
                        this.timeout = setTimeout(() => {
                            this.reset();
                        }, 100);

                        this._input += e.key;
                    }
                }

                if (this.debug) {
                    this.debugView.style.height = "5px";
                    this.debugView.style.height = (this.debugView.scrollHeight) + "px";
                }


                //console.log(e.key);
            };

        }

        reset() {
            this._input = "";
            this._reading = false;
            this.timeout = null;
        }

        hasBoundCommand(command: string) {
            return this.code_commands[command]?.length > 0;
        }

        async performScan(code: string, external: boolean = true) {
            if (this.paused) return false;

            //paste in allowed input
            if (document.activeElement && document.activeElement.classList.contains("allow-scan")) {
                (document.activeElement as HTMLInputElement).value = code;
                return true;
            }


            //console.log("scanning code:" + code, "external", external);

            if (external && this.debug) {
                this.debugView.value = "Scanned Barcode from external = " + code + "\n";
            }


            var seperator = code.indexOf("_");
            var cmd = false;
            var action = false;



            if (seperator == -1) {
                for (let i = 0; i < this._convertScanMethods.length; i++) {
                    let result = await this._convertScanMethods[i](code);
                    if (result != null && result == false) {
                        return false;
                    }
                }
            }

            if (seperator != -1 && !this.slaveMode) {

                var command = code.substr(0, seperator);
                var command_code = code.substr(seperator + 1, code.length - (seperator))


            
                

                var commands = this.code_commands[command];
                if (commands) {
                    for (let i = commands.length - 1; i >= 0; i--) {

                        let m = commands[i];
                        var ctx = (m as any).ctx;
                        var result = m.apply(ctx, [command_code]);
                        cmd = true;
                        action = true;
                        if (result != null && result == false) {
                            //console.log("stopping propergation");
                            break;
                        }
                
                    }

                }
            }
            if (!cmd) {
                var commands = this.code_commands["any"];
                let gs1data: GS1Data = null;
                if (isGS1Barcode(code)) {
                    gs1data = parseGS1Barcode(code);
                    code = gs1data.GTIN;
                }


                if (commands) {
                    for (let i = commands.length - 1; i >= 0; i--) {
                        let m = commands[i];
                        var ctx = (m as any).ctx;
                        var result = m.apply(ctx, [code, gs1data]);
                        if (result != null && result == false) break;
                        action = true;
                    }
                }
            }
            return action;
        }

        pause() {
            this.paused = true;
        }

        resume() {
            this.paused = false;
        }


        on(command: string, method: (...args: any[]) => void, ctx: any) {
            if (!command || !command.length) command = "any";
            if (this.code_commands[command] == null)
                this.code_commands[command] = [];

            (method as any).ctx = ctx;
            this.code_commands[command].push(method);
        }

        off(command: string, method: (...args: any[]) => void) {
            if (!command || !command.length) command = "any";
            if (this.code_commands[command] != null) {
                this.code_commands[command].splice(this.code_commands[command].indexOf(method), 1);
            }
        }
    }
}